import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import i18n from '../../../translations/i18n';
import { Client } from '../../../api/clientsApi/interfaces';
import { AgentBadge } from '../../../components/AgentBadge';
import { AgentsAvatarCell, DateCell } from '../../../components/data-table';

export const columns: GridColDef[] = [
  {
    field: 'name',
    headerName: i18n.t('entities:client.name'),
    width: 200,
    hideable: false,
  },
  {
    field: 'group',
    headerName: i18n.t('entities:client.group'),
    width: 130,
    valueGetter: (params) => {
      const group = params as Client['group'];

      return group?.name || '-';
    },
  },
  {
    field: 'sector',
    headerName: i18n.t('entities:client.sector'),
    width: 130,
    valueGetter: (params) => {
      const sector = params as Client['sector'];

      return sector.name;
    },
  },
  {
    field: 'numberOfRooms',
    headerName: i18n.t('entities:client.numberOfRooms'),
    width: 150,
    valueGetter: (params) => {
      const numberOfRooms = params as Client['numberOfRooms'];

      return numberOfRooms
        ? i18n.t('clients:totalNumberOfRooms', { count: numberOfRooms })
        : '-';
    },
  },
  {
    field: 'island',
    headerName: i18n.t('entities:client.island'),
    width: 130,
    valueGetter: (params) => {
      const island = params as Client['island'];

      return island.name;
    },
  },
  {
    field: 'area',
    headerName: i18n.t('entities:client.area'),
    width: 130,
    valueGetter: (params) => {
      const area = params as Client['area'];

      return area?.name || '-';
    },
  },
  {
    field: 'status',
    headerName: i18n.t('entities:client.status'),
    width: 130,
    valueGetter: (params) => {
      return i18n.t(`entities:client.enums.status.${params as string}`);
    },
  },
  {
    field: 'contactInterval',
    headerName: i18n.t('entities:client.contactInterval'),
    width: 130,
    valueGetter: (params) => {
      return params ? i18n.t('words.month', { count: params / 30 }) : '-';
    },
  },
  {
    field: 'responsibleAgents',
    headerName: i18n.t('entities:client.responsibleAgents'),
    filterable: false,
    minWidth: 220,
    flex: 1,
    renderCell: (params) => {
      const row = params.row;

      return <AgentsAvatarCell agents={row.responsibleAgents} />;
    },
  },
  {
    field: 'createdBy',
    headerName: i18n.t('entities:common.createdBy'),
    filterable: false,
    minWidth: 160,
    flex: 1,
    renderCell: (params) => {
      const row = params.row;

      return <AgentBadge agent={row.createdBy} />;
    },
  },
  {
    field: 'createdAt',
    headerName: i18n.t('entities:common.createdAt'),
    filterable: false,
    minWidth: 160,
    flex: 1,
    renderCell: (params) => {
      const row = params.row;

      return <DateCell date={row.createdAt} />;
    },
  },
];
